<template>
  <van-tabbar v-model="curActive" route>
    <van-tabbar-item
      v-for="(item, index) in tabbarList"
      :key="index"
      replace
      @click="goLink(item.path)"
    >
      <span :class="curActive == index ? 'selected' : 'select'">{{
        item.title
      }}</span>
      <template #icon="props">
        <img
          :src="curActive == index ? item.icon.active : item.icon.inactive"
        />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: "vHeader",
  props: {
    active: {
      default: 0,
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      curActive: this.active,
    };
  },
  computed: {
    tabbarList: function () {
      return [
        {
          title: "首页",
          path: "/",
          icon: {
            active: require("../../assets/img/tabar/shouye-on.png"),
            inactive: require("../../assets/img/tabar/shouye-off.png"),
          },
        },
        {
          title: "行情",
          path: "/Market",
          icon: {
            active: require("../../assets/img/tabar/hangqing-on.png"),
            inactive: require("../../assets/img/tabar/hangqing-off.png"),
          },
        },
        {
          title: "交易",
          path: "/Exchange",
          icon: {
            active: require("../../assets/img/tabar/jiaoyi-on.png"),
            inactive: require("../../assets/img/tabar/jiaoyi-off.png"),
          },
        },
        {
          title: "我的",
          path: "/My",
          icon: {
            active: require("../../assets/img/tabar/wode-on.png"),
            inactive: require("../../assets/img/tabar/wode-off.png"),
          },
        },
      ];
    },
  },
  methods: {
    goLink(path) {
      if (this.$route.path === path) {
        this.$router.replace({ path: "/refresh", query: { target: path } });
      } else {
        this.$router.push({ path });
      }
    },
  },
};
</script>

<style scoped>
.select {
  color: #9393a3 !important;
}

.selected {
  color: #f89b19;
}

.van-tabbar {
  background: transparent !important;
  border: 1px solid #f89b19;
  border-radius: 10px 10px 0px 0px;
}

.deeptabbar-item--active {
  background: transparent;
}
</style>
